import { FC, ReactNode } from "react"
import {
  Dialog as DialogPrimitive,
  DialogFooter,
  DialogHeader,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogClose,
  DialogTrigger,
  Button,
} from "../ui"

type DialogPropsType = {
  title?: string,
  children: ReactNode,
  handleAccept?: () => void,
  close: () => void,
  acceptLabel?: string,
  closeLabel?: string,
  isVisible: boolean,
  hideButtonGroup?: boolean,
}

export const Dialog: FC<DialogPropsType> = ({
  title,
  children,
  handleAccept,
  close,
  acceptLabel,
  closeLabel,
  isVisible,
  hideButtonGroup = false,
}) => {
  return (
    <DialogPrimitive
      open={isVisible}
      onOpenChange={close}
    >
      <DialogTrigger />
      <DialogContent className="flex flex-col w-[calc(100vw-1rem)] max-w-none h-[calc(100vh-1rem)] sm:max-w-lg sm:h-auto sm:grid">
        {title && <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>}
        <DialogDescription className="flex-grow overflow-y-auto overflow-x-hidden">
          {children}
        </DialogDescription>
        {!hideButtonGroup && <DialogFooter className="flex gap-1">
          <DialogClose className="w-full">
            <Button
              variant={"outline"}
              className="w-full rounded"
            >
              {closeLabel ? closeLabel : "close"}
            </Button>
          </DialogClose>
          <Button
            onClick={handleAccept}
            className="w-full"
          >
            {acceptLabel ? acceptLabel : "accept"}
          </Button>

        </DialogFooter>}
      </DialogContent>
    </DialogPrimitive>

  )

}
